import React, { ReactElement, ReactNode } from 'react';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import { getDefaultOtherName } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { OrganisationOtherNameDTO, ProjectOtherNameDTO } from '../../../../api/core';
import { InputGroup } from '../layout/InputGroup';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { Panel } from '../layout/Panel';

export type OtherName = OrganisationOtherNameDTO & ProjectOtherNameDTO;

interface OtherNamesProps {
  checkPermission: CheckPermissionFunction;
  otherNames: OtherName[];
  onChange: (change: OtherName[]) => void;
  validation: ValidationResult;
  label: string;
  autoFocus: boolean;
}

export function OtherNames(props: OtherNamesProps): ReactNode {
  return (
    <Panel title={`${props.label}`} toggleable={true}>
      <MultiInputControls<OtherName>
        lines={props.otherNames}
        onChange={props.onChange}
        canEdit={props.checkPermission().canWrite}
        renderLines={(otherNameDTO: OtherName, onChange2: (_otherNames: OtherName) => void, actions: Actions, idx: number): ReactElement => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <LabelledInputText
                id={`otherName${idx}`}
                autoFocus={props.autoFocus}
                value={otherNameDTO.otherName}
                permissions={props.checkPermission('other_name')}
                validation={props.validation?.children[idx]?.fields?.other_name}
                disabled={!props.checkPermission('other_name').canWrite}
                onChange={(otherName: string): void => onChange2({...otherNameDTO, otherName})}
                label={`${props.label}.attr.otherName`}
              />
            </InputGroup>
          );
        }}
        addNew={(row: OtherName[]): number => row.push(getDefaultOtherName())}/>
    </Panel>
  );
}
